import { Tabs } from '@monorepo/base/src/components/tabs/tabs';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../../stores';
import React, { useEffect, useState } from 'react';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { observer } from 'mobx-react';
import { Spinner } from '@monorepo/base/src/components/spinner/spinner';
import { Flex } from '@monorepo/base/src/components/flex/flex';
import { Spacer } from '@monorepo/base/src/components/spacer/spacer';
import { Budget } from './budget';

type Props = {
	id: id;
};

export const BudgetInlineEditModal = observer(({ id }: Props) => {
	const [currentPhaseId, setCurrentPhaseId] = useState<id>();

	const { campaignStore } = useStores<IAdminxStore>();

	const campaign = campaignStore.getCrud().getData();
	const firstPhaseId = campaign.getPhases()?.[0]?.phase.id;
	const currentPhase = campaign.getPhaseById(currentPhaseId);

	// set active tab to first phase on load
	useEffect(() => {
		if (currentPhaseId !== firstPhaseId && firstPhaseId && !currentPhaseId) {
			setCurrentPhaseId(firstPhaseId);
		}
	}, [currentPhaseId, firstPhaseId]);

	useEffect(() => {
		campaignStore
			.getCrud()
			.get(id)
			.then(data => {
				setCurrentPhaseId(data?.getPhases()?.[0]?.phase.id);
			});
	}, [id]);

	return (
		<React.Fragment>
			<div>Edit Daily Budget</div>

			{campaignStore.getCrud().isLoading ? (
				<Flex justifyContent="center" height="260px">
					<Spinner size={'40px'} />
				</Flex>
			) : (
				<React.Fragment>
					<Spacer />

					<Tabs
						showActive
						onTabChange={setCurrentPhaseId}
						activeTabId={currentPhaseId}
						tabs={campaign.getPhases()?.map(p => ({
							...p.phase,
							active: p.active,
						}))}
					/>

					<Spacer />

					<Budget currentPhase={currentPhase} />
				</React.Fragment>
			)}
		</React.Fragment>
	);
});
